<template>
  <div>
    <new-allMaintainQuartzJob showpages="allMaintainQuartzJob"></new-allMaintainQuartzJob>
  </div>
</template>

<script>
import backgroundDetail from '../../../components/backgroundDetail.vue' 
/**
 *@ClassName:fullprojectAutoInspecRepoBD
 *@Description:全项目自动巡检报事-后台详情
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-22
 */
export default {
  components: {
    'new-allMaintainQuartzJob': backgroundDetail 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>